import { Container } from '@material-ui/core';
import React from 'react';

import { CookiePolicyCard, Layout, SEO } from '../components';

export default function Legal(props) {
  return (
    <Layout {...props}>
      <SEO title="Cookie Policy" pathname={props.location.pathname} />
      <Container maxWidth="md">
        <CookiePolicyCard />
      </Container>
    </Layout>
  );
}
